const allowedModules = [
    'Client'
];
if (!allowedModules.includes(global.MODULE)) throw new Error(`Only allowed in ${allowedModules.join(', ')}`);
export { default as UIGame } from './core/UIGame.tsx';
export { createFeedMessageDataForGameChatData } from './core/UIGameFeeds/UIGameFeedMessage/FeedMessageDataChats.ts';
export { addGlobalSpectatorMessage } from './core/UIGameFeeds/UIGameChat/UIGameChat.tsx';
export { addNewLog } from './core/UIGameFeeds/UIGameLog/UIGameLog.tsx';
export { CARD_TOOLTIP_LINK_PREFIX } from './core/UIGameFeeds/UIGameFeedMessage/FeedMessageDataLogs.ts';
export { setGlobalCanResign } from './core/UIGameHelpButtons/UIGameHelpLeaveGameContext.tsx';
export { getCostInformation } from './core/UIGameHelpButtons/UIGameHelpInformationButton/UIGameHelpCostsInformation/UIGameCostsInformation.ts';
export { setGlobalSpectators } from './core/UIGameSpectators/UIGameSpectatorsContext.tsx';
export { CARD_IMAGES, CARD_TIP_TITLE, CARD_TIP_BODY, CARD_POPUP_BODY, CARD_RATIO, getIfCardHasBadgeFromType, cardEnumsToCardState } from './utils/cards.ts';
export { VICTORY_POINT_END_GAME_TIP, VICTORY_POINT_IMAGES } from './utils/vp.ts';
export { GameColor } from './utils/GameColor.ts';
export { getGameWorldZoomClampMultiplier, MOBILE_ZOOM_BOOST, CANVAS_CARD_RATIO, TILE_RATIO } from './utils/map.ts';
export { CurrentStateMessageUtils } from './core/UIGameCurrentStatus/CurrentStateMessageUtils.ts';
export { getGlobalPositionOfPlayerCard } from './core/UIGamePlayerInformation/index.ts';
export { getPointPositionFromBank } from './core/UIGameBank/UIGameBank.tsx';
// eslint-disable-next-line max-len
export { getPointPositionFromPlayerInventory, getCardDimensionsFromPlayerInventory } from './core/UIGamePlayerCardInventory/UIGamePlayerCardInventory.tsx';
export { UIGameAchievementEventEmitter } from './core/UIGameAchievement/UIGameAchievementContainer.tsx';
export { createGameStore } from './store/gameStore.ts';
export { GAME_ACTION_TO_BEGINNER_HINT_TYPE } from './core/UIGameBeginnerHint/utils.ts';
